import { put, takeLatest } from 'redux-saga/effects';
import { fetchSRPFilterInitialLoadFailure, fetchSRPFilterInitialLoadSuccess, fetchSRPSortInitialLoadFailure, fetchSRPSortInitialLoadSuccess, fetchStateInitialLoadSuccess } from './srpFilterSlice';
import { getSRPFilter, getStateList } from '@/api/srpFilter';
import { filterList, sortFilterConfig } from './data';

export function* fetchSRPFilterInitSaga(action) {
  const response = yield getSRPFilter(action.payload);
  if (response?.filterConfig?.filterList) {
    yield put(fetchSRPFilterInitialLoadSuccess(response?.filterConfig?.filterList));
  } else {
    yield put(fetchSRPFilterInitialLoadFailure(filterList));
  }
  if (response?.filterConfig?.sortFilterConfig) {
    yield put(fetchSRPSortInitialLoadSuccess(response?.filterConfig?.sortFilterConfig));
  } else {
    yield put(fetchSRPSortInitialLoadFailure(sortFilterConfig));
  }
}

export function* fetchStateInitSaga() {
  const response = yield getStateList();
  if (response) {
    yield put(fetchStateInitialLoadSuccess(response));
  }
}

export function* watchFetchSRPFilterInitSaga() {
  // yield takeLatest('srpFilter/fetchSRPFilterInitialLoad', fetchSRPFilterInitSaga);
  yield takeLatest('srpFilter/fetchStateInitialLoad', fetchStateInitSaga);
}
